module.exports = __webpack_public_path__ + "static/media/COPING_TASK.835e309c.md";